<main class="main-layout">
  <div class="sidebar-backdrop d-lg-none" *ngIf="sidebarOpen" (click)="closeSidebar()"></div>
  <div class="sidebar" [class.is-open]="sidebarOpen">
    <!-- Brand -->
    <div class="nav-brand">
      <a [routerLink]="homeUrl" class="nav-brand__tile"
        [class.nav-brand__tile--custom]="branding.logoUrl" [title]="branding.name || 'Menassaty'">
        <img *ngIf="branding.logoUrl; else defaultLogo" [src]="branding.logoUrl" [alt]="branding.name || 'Logo'" />
        <ng-template #defaultLogo><i class="bi bi-mortarboard-fill"></i></ng-template>
      </a>
      <div class="nav-brand__meta">
        <p class="nav-brand__name">{{ branding.name || ("app.Menassaty" | translate) }}</p>
        <div class="nav-brand__status">
          <span class="nav-brand__dot"></span>
          <span dir="rtl">منصتي</span>
        </div>
      </div>
    </div>

    <!-- Sections: one per product pillar, gated by role, tenant module, plan and page access -->
    <nav class="navbar-nav" [attr.aria-label]="'navigation.MainMenu' | translate">
      <div class="nav-group" *ngFor="let vg of visibleGroups; trackBy: trackGroup"
        [class.is-open]="isGroupOpen(vg.group)" [ngStyle]="groupAccentVars(vg.group)"
        [attr.data-nav-group]="vg.group.key">
        <button type="button" class="nav-group__header" (click)="toggleGroup(vg.group)"
          [attr.aria-expanded]="isGroupOpen(vg.group)">
          <span class="nav-group__badge"><i [ngClass]="vg.group.icon" aria-hidden="true"></i></span>
          <span class="nav-group__title">{{ vg.group.titleKey | translate }}</span>
          <span class="nav-group__count">{{ vg.items.length }}</span>
          <i class="nav-group__chevron bi bi-chevron-right" aria-hidden="true"></i>
        </button>

        <div class="nav-group__panel" *ngIf="isGroupOpen(vg.group)" @expandGroup>
          <span class="nav-group__connector" aria-hidden="true"></span>
          <ul class="nav-group__items">
            <li class="nav-item" *ngFor="let vi of vg.items; trackBy: trackItem">
              <a class="nav-link" [routerLink]="vi.item.route" [queryParams]="vi.item.queryParams ?? null"
                [class.active]="vi.item.id === activeItemId"
                [attr.aria-current]="vi.item.id === activeItemId ? 'page' : null"
                [attr.data-nav-item]="vi.item.id" (click)="closeSidebar()">
                <span class="nav-link__icon"><i class="icon {{ vi.item.icon }}" aria-hidden="true"></i></span>
                <span class="nav-link__text">{{ vi.label }}</span>
                <span class="nav-badge" *ngIf="badgeCount(vi.item) > 0">{{ badgeCount(vi.item) }}</span>
                <span class="nav-link__dot" *ngIf="badgeCount(vi.item) === 0" aria-hidden="true"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- User card + sign out -->
    <div class="nav-foot">
      <a *ngIf="settingsVisible; else plainUser" routerLink="/settings" class="nav-user">
        <ng-container *ngTemplateOutlet="userInner"></ng-container>
        <i class="bi bi-gear nav-user__gear" aria-hidden="true"></i>
      </a>
      <ng-template #plainUser>
        <div class="nav-user nav-user--static">
          <ng-container *ngTemplateOutlet="userInner"></ng-container>
        </div>
      </ng-template>
      <ng-template #userInner>
        <span class="nav-user__avatar">
          {{ auth.getFullName() | slice:0:2 | uppercase }}
          <span class="nav-user__online" aria-hidden="true"></span>
        </span>
        <span class="nav-user__meta">
          <span class="nav-user__name">{{ auth.getFullName() }}</span>
          <span class="nav-user__role">{{ branding.name || ("app.Menassaty" | translate) }}</span>
        </span>
      </ng-template>

      <a href="#" class="logout" (click)="logout()">
        <i class="bi bi-box-arrow-right" aria-hidden="true"></i>
        <span>{{ "app.Logout" | translate }}</span>
      </a>
    </div>
  </div>

  <div class="main-content">
    <div class="billing-banner" *ngIf="billingNotice" [class.billing-banner--danger]="billingReadOnly">
      <span>{{ billingNotice }}</span>
      <a routerLink="/settings/billing" class="billing-banner__cta">{{ "app.ManageBilling" | translate }}</a>
    </div>
    <div class="header-area">
      <button type="button" class="btn-burger d-lg-none" (click)="toggleSidebar()"
        [attr.aria-label]="'app.Menu' | translate">
        <i class="bi bi-list"></i>
      </button>
      <div class="header-title">
        <h1 class="header-title__page">{{ selectedText }}</h1>
        <p class="header-title__date">{{ today }}</p>
      </div>

      <div class="header-actions">
        <button class="btn-lang" (click)="toggleLang()">
          <span>{{ currentLang === 'en' ? 'AR' : 'EN' }}</span>
        </button>
        <div class="dropdown notification">
              <button
                class="dropdown-btn"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="icon ico-notification"></i>
                <span class="pulse" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
              </button>
              <ul class="dropdown-menu dropdown-menu-end" style="min-width:min(320px, 88vw);max-height:420px;overflow-y:auto;">
                <li class="dropdown-header d-flex justify-content-between align-items-center px-3 py-2">
                  <strong>{{ "app.Notifications" | translate }}</strong>
                  <button class="btn btn-sm btn-link p-0" (click)="markAllRead()" *ngIf="unreadCount > 0">
                    {{ "app.MarkAllRead" | translate }}
                  </button>
                </li>
                <li *ngIf="recentNotifications.length === 0">
                  <span class="dropdown-item text-muted">{{ "app.NoNotifications" | translate }}</span>
                </li>
                <li *ngFor="let n of recentNotifications">
                  <a class="dropdown-item" [class.fw-bold]="!n.isRead" href="#" (click)="openNotification(n); $event.preventDefault()">
                    <div class="d-flex flex-column">
                      <span class="text-truncate" style="max-width:280px;">{{ notifTitle(n) }}</span>
                      <small class="text-muted">{{ notifBody(n) }}</small>
                    </div>
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                  <a class="dropdown-item text-center" routerLink="/notifications">{{ "app.ViewAll" | translate }}</a>
                </li>
              </ul>
            </div>
            <button class="btn-lang" (click)="logout()">
              <i class="icon ico-logout"></i>
            </button>
            <div class="header-user">
              <span class="header-user__avatar">{{ auth.getFullName() | slice:0:2 | uppercase }}</span>
              <div class="header-user__meta">
                <p class="header-user__name">{{ auth.getFullName() }}</p>
                <p class="header-user__role">{{ branding.name || ('app.Menassaty' | translate) }}</p>
              </div>
            </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</main>
